export default __webpack_public_path__ + "static/media/visa-logo.8c182eba.svg";